import authApi from './endpoints/auth.api';
import createCustomerApi from './endpoints/msw-create-customer.api';
import widgetsApi from './endpoints/msw-widgets.api';
import downloadCenterApi from './endpoints/msw-download-center.api';
import ordersAPI from './endpoints/msw-orders.api';
import msspTenantAPI from './endpoints/msw-tenant-management.api';
import usageReportApi from './endpoints/msw-usage-report.api';
import userListApi from './endpoints/msw-user-list.api';
import userGroupApi from './endpoints/msw-user-group.api';
import affiliationsApi from './endpoints/msw-affiliations.api';

import getCountriesApi from './endpoints/msw-get-countries.api';
import promotionsAPI from './endpoints/sandbox-promotions.api';
import editquoteAPI from './endpoints/sanbox-edit-quote.service.api';
import preffileReportApi from './endpoints/msw-pref-file-download-report.api';
class MswApiService {
  auth = authApi;
  affiliations = affiliationsApi;
  createCustomer = createCustomerApi;
  widgetsInfo = widgetsApi;
  downloadCenter = downloadCenterApi;
  orders = ordersAPI;
  tenant = msspTenantAPI;
  usageReport = usageReportApi;
  userListSection = userListApi;
  userGroup = userGroupApi;
  getCountries = getCountriesApi;
  promotions = promotionsAPI;
  editQuote = editquoteAPI;
  preffileReport = preffileReportApi;
}

export default new MswApiService();
